import { ThirdPartyReports } from 'QuoteApp/services/endpoints/GetDetails/types';
import { useAppContext } from 'QuoteApp/services/providers';

/*
  undisclosedDriversFlag:
    Based on the presence of the driver discovery report command
    Reznor FF: ENABLE_DRIVER_DISCOVERY

  homeownerVerificationFlag:
    Based on configuration endpoint insurable party
    Reznor FF: EENABLE_HOMEOWNER_VERIFICATION
*/

export const useQuoteAppFeatureFlags = () => {
  const { details, config } = useAppContext();

  return {
    undisclosedDriversFlag: Boolean(
      details.commands.reports.find(
        (r) => r.reportName === ThirdPartyReports.DriverDiscovery
      )
    ),
    homeownerVerificationFlag: Boolean(config?.drivers.homeownerVerification),
    selfReportedAccidentsForClassificationsFlag: Boolean(
      config?.drivers.accidents.typeOfLoss?.required || false
    ),
    collectDayOfAccidentFlag: Boolean(
      config?.drivers.accidents.collectDayOfAccident || false
    ),
    showLendingLossesFlag: Boolean(
      config?.drivers.accidents.showLendingLosses || false
    ),
    assumeAtFaultFlag: Boolean(
      config?.drivers.accidents.assumeAtFault || false
    ),
    collectTypeOfLossFlag: Boolean(
      config?.drivers.accidents.collectTypeOfLoss || false
    ),
  };
};
